import React from 'react';
import Image from '@/components/atoms/Image';
import Button from '@/components/atoms/button';
import Typography from '@/components/atoms/typography';
import Link from '@/components/atoms/link';

const LandingPageBanner = ({ data }: any) => {
    const banner = data?.homepageBanner?.media?.file;
    const title = data?.bannerTitle;
    const subtitle = data?.bannerSubTitle;
    const projectImage = data["project image"]?.media.file;
    return (
        <div className="relative w-full h-[220px] md:h-[387px]">
            {banner && (
                <Image
                    src={banner}
                    alt={title ?? ''}
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
            )}
            {projectImage && (
                <>
                    {/* Where's My Order button hidden per requirement (login screen and banner) */}
                    {/* <Link link={"/where-is-my-order"} >
                        <button className='!bg-opacity-20 !border-opacity-30 cursor-pointer absolute right-[48px] top-[22px] !z-40 text-[#ffffff] border-[#ffffff] !border-[1px] !rounded-full !flex !gap-[9px] items-center !bg-[#ffffff] !px-[20px] !py-[6px]' >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                            <Typography className='text-[#ffffff] text-[16px] font-semibold' >
                                Where's My Order
                            </Typography>
                        </button>
                    </Link> */}
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none">

                        <div className="!absolute top-0 left-0 w-full h-full bg-black/40 z-0" />
                        <div className="relative z-10 flex flex-col items-center justify-center w-full md:items-end md:px-10 md:justify-end md:text-right">
                            <Image
                                src={projectImage}
                                alt="Project"
                                className="w-[274.12px] h-[80.81px] md:w-[473px] md:h-[139px] opacity-100 rotate-0 max-w-full"
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LandingPageBanner;
